export default "__VITE_ASSET__rexRX5x1__"